module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMyQzJDMkMiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyIDBBMTIuMDE5IDEyLjAxOSAwIDAgMCAuOTYgNy4zMDZWMEgwdjguMTZjMCAuMjY5LjIxMS40OC40OC40OGg4LjE2di0uOTZIMS44NDNBMTEuMDU1IDExLjA1NSAwIDAgMSAxMiAuOTZDMTguMDg2Ljk2IDIzLjA0IDUuOTE0IDIzLjA0IDEyYzAgNi4wODYtNC45NTQgMTEuMDQtMTEuMDQgMTEuMDRWMjRjNi42MTQgMCAxMi01LjM4NiAxMi0xMlMxOC42MTQgMCAxMiAweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/revert-arrow.svg
// module id = 928
// module chunks = 0